import AppRoutes from "./router.tsx"
import NavBar from "./components/NavBar.tsx";
import {useContext, useEffect, useRef} from "react";
import AuthContext from "./contexts/AuthContext.tsx";
import Footer from "./components/Footer.tsx";
import {Box} from "@mui/material";
import {useIdleTimer} from "react-idle-timer";
import {onMessageListener} from "./functions/firebase.ts";
import {useLocation} from "react-router-dom";

const IdleLogoutHandler = ({isLoggedIn, logoutMutation}: { isLoggedIn: boolean; logoutMutation: any }) => {
    const idleTimerRef = useRef(null);

    useIdleTimer({
        ref: idleTimerRef,
        timeout: 15 * 60 * 1000, // 15 minutes
        onIdle: () => {
            if (isLoggedIn) {
                logoutMutation.mutate();
            }
        },
        debounce: 500,
        events: ['mousemove', 'keydown', 'touchstart', 'scroll'],
        crossTab: true,
        startOnMount: true,
    });

    return null;
};

const ScrollRestorationControl = () => {
    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    return null;
};

const GlobalScrollHandler = () => {
    const location = useLocation();

    useEffect(() => {
        // If NOT on a category page, scroll to top manually
        if (!location.pathname.startsWith('/category/') && location.pathname !== ('/')) {
            window.scrollTo(0, 0);
        }
        // Else (on category page), do nothing - ProductList handles it
    }, [location.pathname]);

    return null;
};


function App() {
    const {fetchingLoginStatus, isLoggedIn, logoutMutation} = useContext(AuthContext);

    useEffect(() => {
        const handleForegroundMessage = (payload: any) => {
            const {title, body} = payload.notification;

            if (Notification.permission === 'granted') {
                const notification = new Notification(title, {
                    body,
                    icon: '/icon-192.png',
                    data: {
                        link: payload.data?.link,
                    }
                });

                notification.onclick = (event) => {
                    event.preventDefault();
                    if (notification.data?.link) {
                        window.open(notification.data.link, '_blank');
                    }
                };
            }
        };

        onMessageListener(handleForegroundMessage);
    }, []);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
            }}
        >
            <GlobalScrollHandler/>
            <ScrollRestorationControl/>
            <IdleLogoutHandler isLoggedIn={isLoggedIn} logoutMutation={logoutMutation}/>
            <NavBar/>
            <Box sx={{flex: 1}}>
                {!fetchingLoginStatus ? <AppRoutes/> : null}
            </Box>
            <Footer/>
        </Box>
    )
}

export default App
